import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGpsrStore,
	TGpsrProductTypesRequest,
	TGpsrProductTypesResponsePayload,
	TGpsrSkuRequest,
	TGpsrSkuResponsePayload,
	TGpsrStatusResponsePayload,
	TGpsrAttachSkuRequest,
	TGpsrDeleteSkuRequest,
	TGpsrGenerateDocRequest,
	TGpsrUploadDocRequest,
	TGpsrDownloadDocRequest,
	TGpsrUpdateDescriptionRequest,
	TGpsrAttachSkuResponsePayload,
	TGpsrUploadTechFileRequest,
	TGpsrGetTechFileRequest,
	TGpsrAdditionalInformationResponsePayload,
	TGpsrCancellationRequest,
	TGpsrPlansResponsePayload,
	TChangeGpsrServiceRequest,
	TGpsrConfirmAdditionalInformationResponsePayload,
} from './types';
// ==========================================:
export const initialState: TGpsrStore = {
	gpsrStatus: null,
	gpsrStatusLoading: false,
	gpsrProductTypes: null,
	gpsrProductTypesLoading: false,
	gpsrSkus: null,
	gpsrSkusLoading: false,
	gpsrAttachSkuLoading: false,
	gpsrAttachSkuMessage: null,
	gpsrDeleteSkuLoading: false,
	gpsrGenerateDocLoading: false,
	gpsrGeneratedDoc: null,
	gpsrUploadDocLoading: false,
	gpsrDownloadDocLoading: false,
	gpsrUpdateDescriptionLoading: false,
	gpsrUploadTechFileLoading: false,
	gpsrGetTechFileLoading: false,
	gpsrUploadTechFile: null,
	gpsrGetTechFile: null,
	gpsrAdditionalInformation: null,
	gpsrAdditionalInformationLoading: false,
	gpsrCancellationLoading: false,
	gpsrPlans: null,
	gpsrPlansLoading: false,
	gpsrChangeServiceLoading: false,
	gpsrConfirmAdditionalInformationLoading: false,
};

// ==========================================:
const gpsr = createSlice({
	name: '@@gpsr',
	initialState,
	reducers: {
		getGpsrStatusRequest: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrStatusLoading = true;
		},
		getGpsrStatusSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrStatusResponsePayload>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrStatus = action.payload;
			gpsrState.gpsrStatusLoading = false;
		},
		getGpsrProductTypesRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrProductTypesRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrProductTypesLoading = true;
		},
		getGpsrProductTypesSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrProductTypesResponsePayload>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrProductTypes = action.payload;
			gpsrState.gpsrProductTypesLoading = false;
		},
		getGpsrSkusRequest: (state: TGpsrStore, action: PayloadAction<TGpsrSkuRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrSkusLoading = true;
		},
		getGpsrSkusSuccess: (state: TGpsrStore, action: PayloadAction<TGpsrSkuResponsePayload>) => {
			const gpsrState = state;
			gpsrState.gpsrSkus = action.payload;
			gpsrState.gpsrSkusLoading = false;
		},
		attachSkusRequest: (state: TGpsrStore, action: PayloadAction<TGpsrAttachSkuRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrAttachSkuLoading = true;
			gpsrState.gpsrAttachSkuMessage = null;
		},
		attachSkusSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrAttachSkuResponsePayload>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrAttachSkuMessage = action.payload;
			gpsrState.gpsrAttachSkuLoading = false;
		},
		attachSkusReset: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrAttachSkuMessage = null;
			gpsrState.gpsrAttachSkuLoading = false;
		},
		deleteSkuRequest: (state: TGpsrStore, action: PayloadAction<TGpsrDeleteSkuRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrDeleteSkuLoading = true;
		},
		deleteSkuSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrDeleteSkuLoading = false;
		},
		generateGpsrDocRequest: (state: TGpsrStore, action: PayloadAction<TGpsrGenerateDocRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrGenerateDocLoading = true;
		},
		generateGpsrDocSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrGenerateDocLoading = false;
		},
		uploadGpsrDocRequest: (state: TGpsrStore, action: PayloadAction<TGpsrUploadDocRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrUploadDocLoading = true;
		},
		uploadGpsrDocSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrUploadDocLoading = false;
		},
		downloadGpsrDocRequest: (state: TGpsrStore, action: PayloadAction<TGpsrDownloadDocRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrDownloadDocLoading = true;
		},
		downloadGpsrDocSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrDownloadDocLoading = false;
		},
		updateGpsrDescription: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrUpdateDescriptionRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrUpdateDescriptionLoading = true;
		},
		updateGpsrDescriptionSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrUpdateDescriptionLoading = false;
		},
		uploadGpsrTechFileRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrUploadTechFileRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrUploadTechFileLoading = true;
		},
		uploadGpsrTechFileSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrUploadTechFileLoading = false;
		},
		getGpsrTechFileRequest: (state: TGpsrStore, action: PayloadAction<TGpsrGetTechFileRequest>) => {
			const gpsrState = state;
			gpsrState.gpsrGetTechFileLoading = true;
		},
		getGpsrTechFileSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrGetTechFileLoading = false;
		},
		getGpsrAdditionalInformationRequest: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrAdditionalInformationLoading = true;
		},
		getGpsrAdditionalInformationSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrAdditionalInformationResponsePayload>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrAdditionalInformation = action.payload;
			gpsrState.gpsrAdditionalInformationLoading = false;
		},
		getGpsrCancellationRequest: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrCancellationRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrCancellationLoading = true;
		},
		getGpsrCancellationSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrCancellationLoading = false;
		},
		getGpsrPlansRequest: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrPlansLoading = true;
		},
		getGpsrPlansSuccess: (state: TGpsrStore, action: PayloadAction<TGpsrPlansResponsePayload>) => {
			const gpsrState = state;
			gpsrState.gpsrPlans = action.payload;
			gpsrState.gpsrPlansLoading = false;
		},
		confirmGpsrAdditionalInformationRequest: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrConfirmAdditionalInformationLoading = true;
		},
		confirmGpsrAdditionalInformationSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGpsrConfirmAdditionalInformationResponsePayload>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrConfirmAdditionalInformationLoading = false;
		},
		changeGpsrServiceRequest: (
			state: TGpsrStore,
			action: PayloadAction<TChangeGpsrServiceRequest>,
		) => {
			const gpsrState = state;
			gpsrState.gpsrChangeServiceLoading = true;
		},
		changeGpsrServiceSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.gpsrChangeServiceLoading = false;
		},
		gpsrInitState: () => initialState,
	},
});

export default gpsr.reducer;
export const {
	getGpsrStatusRequest,
	getGpsrStatusSuccess,
	getGpsrProductTypesRequest,
	getGpsrProductTypesSuccess,
	getGpsrSkusRequest,
	getGpsrSkusSuccess,
	attachSkusRequest,
	attachSkusSuccess,
	attachSkusReset,
	deleteSkuRequest,
	deleteSkuSuccess,
	generateGpsrDocRequest,
	generateGpsrDocSuccess,
	uploadGpsrDocRequest,
	uploadGpsrDocSuccess,
	downloadGpsrDocRequest,
	downloadGpsrDocSuccess,
	updateGpsrDescription,
	updateGpsrDescriptionSuccess,
	uploadGpsrTechFileRequest,
	uploadGpsrTechFileSuccess,
	getGpsrTechFileRequest,
	getGpsrTechFileSuccess,
	getGpsrAdditionalInformationRequest,
	getGpsrAdditionalInformationSuccess,
	getGpsrCancellationRequest,
	getGpsrCancellationSuccess,
	getGpsrPlansRequest,
	getGpsrPlansSuccess,
	changeGpsrServiceRequest,
	changeGpsrServiceSuccess,
	confirmGpsrAdditionalInformationRequest,
	confirmGpsrAdditionalInformationSuccess,
	gpsrInitState,
} = gpsr.actions;
